<template>
  <v-select
    :items="[{text:'Yes', value: true},{text: 'No', value: false}]"
    item-text="text"
    item-value="value"
    outlined
    dense
    :placeholder='placeholder'
    style='width:300px;'
    @change="$emit('input', $event)"
    :value='value'
  >
  </v-select>
</template>
<script>
export default{
  props: {
    value:{
      type: String,
      required: true
    },
    question: {
      type: Object,
      required: true
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Please select'
    }
  },
  data(){
    return {}
  },
  methods:{},
  computed: {
    placeholder() {
      return this.question.placeholder || 'Please select'
    },
  },
}
</script>
